import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PrivateComponent } from './private.component';

const routes: Routes = [
  {
    path: '',
    component: PrivateComponent,
    children: [
      {
        path: '',
        redirectTo: 'subscriptions',
        pathMatch: 'full',
      },
      {
        path: 'login-referrer',
        redirectTo: 'subscriptions',
        pathMatch: 'full',
      },
      {
        path: 'overview',
        redirectTo: 'subscriptions',
      },
      {
        path: 'journey',
        loadComponent: () =>
          import('./modules/tenant-journey/screens/tenant-journey-wizard.screen.component').then(
            (module) => module.TenantJourneyWizardScreenComponent,
          ),
      },
      {
        path: 'tile',
        loadChildren: () =>
          import('@suvo/frontend-framework/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/tile/module').then(
            (module) => module.TileModule,
          ),
      },
      {
        path: 'property',
        loadChildren: () =>
          import('./modules/property/module').then((module) => module.PropertyModule),
      },
      {
        path: 'pages',
        loadChildren: () =>
          import('./modules/pages/pages.module').then((module) => module.PagesModule),
      },
      {
        path: 'data-sources',
        loadChildren: () =>
          import('./modules/data-sources/data-sources.routes').then((m) => m.default),
      },
      {
        path: 'subscriptions',
        loadChildren: () =>
          import('./modules/subscriptions/subscriptions.module').then(
            (module) => module.SubscriptionsModule,
          ),
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./modules/settings/settings.module').then((module) => module.SettingsModule),
      },
      {
        path: 'theme',
        loadChildren: () => import('./modules/theme').then((module) => module.ThemeModule),
      },
      {
        path: 'account',
        loadChildren: () =>
          import('./modules/account/account.module').then((module) => module.AccountModule),
      },
      {
        path: 'media',
        loadChildren: () =>
          import('@suvo-media/modules/media/media.module').then((module) => module.MediaModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PrivateRoutingModule {}
